/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
const getStaffIcon = (gradeCode?: string): string => {
  const g = String(gradeCode || '').toUpperCase();
  if (g.includes('LTN') || g.includes('CNE')) return '🧑‍✈️';
  if (g.includes('SGT') || g.includes('ADJ')) return '🧑‍🚒';
  return '👨‍🚒';
};

interface StaffModerationTabProps {
  userId: any;
  filteredItems: any;
  thCls: any;
  tdCls: any;
  editingId: any;
  editForm: any;
  setEditForm: any;
  startEdit: any;
  cancelEdit: any;
  handleSave: any;
  handleDelete: any;
  lookup: any;
  buildingOptions: any;
}

const StaffModerationTab: React.FC<StaffModerationTabProps> = ({
  userId,
  filteredItems,
  thCls,
  tdCls,
  editingId,
  editForm,
  setEditForm,
  startEdit,
  cancelEdit,
  handleSave,
  handleDelete,
  lookup,
  buildingOptions,
}) => (
        <div className="overflow-x-auto rounded border border-[#33456f]">
          <table className="w-full min-w-[960px] border-collapse text-left">
            <thead>
              <tr>
                <th className={thCls}>ID</th>
                <th className={thCls}>Identité</th>
                <th className={thCls}>Grade</th>
                <th className={thCls}>Statut général</th>
                <th className={thCls}>Planning</th>
                <th className={thCls}>Caserne</th>
                <th className={thCls}>Actif</th>
                <th className={thCls}>Groupe</th>
                <th className={`${thCls} w-[1%]`}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.map((s: any) => {
                const isEd = editingId === Number(s.id);
                return (
                  <React.Fragment key={s.id}>
                    <tr>
                      <td className={tdCls}>#{s.id}</td>
                      <td className={tdCls}>
                        <div className="flex items-center gap-1">
                          <span>{getStaffIcon(s.personnel_grade_code)}</span>
                          {!isEd ? (
                            <span>
                              {s.prenom} {s.nom}
                            </span>
                          ) : (
                            <div className="flex flex-col gap-1">
                              <input
                                value={editForm.prenom || ''}
                                onChange={(e) => setEditForm((f: any) => ({ ...f, prenom: e.target.value }))}
                                placeholder="Prénom"
                                className="rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                              />
                              <input
                                value={editForm.nom || ''}
                                onChange={(e) => setEditForm((f: any) => ({ ...f, nom: e.target.value }))}
                                placeholder="Nom"
                                className="rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                              />
                            </div>
                          )}
                        </div>
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <>
                            {s.personnel_grade || s.personnel_grade_code || '—'}
                            <div className="text-[9px] text-slate-500">config #{s.config_personnel_id}</div>
                          </>
                        ) : (
                          <select
                            value={editForm.config_personnel_id || String(s.config_personnel_id || '')}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, config_personnel_id: e.target.value }))}
                            className="w-full max-w-[200px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            {lookup.config_personnel.length === 0 && s.config_personnel_id != null && (
                              <option value={String(s.config_personnel_id)}>#{s.config_personnel_id} (ref.)</option>
                            )}
                            {lookup.config_personnel.map((g: any) => (
                              <option key={g.id} value={String(g.id)}>
                                {g.grade} ({g.grade_code})
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <span className="text-slate-100">{s.staff_status_nom || '—'}</span>
                        ) : (
                          <select
                            value={editForm.staff_status_code || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, staff_status_code: e.target.value }))}
                            className="w-full min-w-[140px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            {lookup.vehicle_statuses.length === 0 && (
                              <option value="">(chargement statuts)</option>
                            )}
                            {lookup.vehicle_statuses.map((st: any) => (
                              <option key={st.id} value={String(st.code || '').toLowerCase()}>
                                {st.nom}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          s.planning_statut_nom || '—'
                        ) : (
                          <select
                            value={editForm.planning_statut_nom || String(s.planning_statut_nom || '')}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, planning_statut_nom: e.target.value }))}
                            className="w-full min-w-[180px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            {lookup.planning_statuses.length === 0 && (
                              <option value={String(s.planning_statut_nom || '')}>
                                {String(s.planning_statut_nom || 'PERSONNELS')}
                              </option>
                            )}
                            {lookup.planning_statuses.map((ps: any) => (
                              <option key={ps} value={ps}>
                                {ps}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          s.batiment_nom || (s.batiment_id ? `#${s.batiment_id}` : '—')
                        ) : (
                          <select
                            value={editForm.batiment_id === undefined ? String(s.batiment_id || '') : editForm.batiment_id}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, batiment_id: e.target.value }))}
                            className="max-w-[200px] rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            <option value="">Aucune</option>
                            {buildingOptions.map((bld: any) => (
                              <option key={bld.id} value={String(bld.id)}>
                                #{bld.id} {bld.nom}
                              </option>
                            ))}
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          Number(s.actif) ? 'Oui' : 'Non'
                        ) : (
                          <select
                            value={editForm.actif || '1'}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, actif: e.target.value }))}
                            className="rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[10px] text-slate-100"
                          >
                            <option value="1">Oui</option>
                            <option value="0">Non</option>
                          </select>
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          s.groupe || '—'
                        ) : (
                          <input
                            value={editForm.groupe || ''}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, groupe: e.target.value }))}
                            className="w-16 rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[11px] text-slate-100"
                            placeholder="A–D"
                          />
                        )}
                      </td>
                      <td className={tdCls}>
                        {!isEd ? (
                          <button type="button" onClick={() => startEdit(s)} className="rounded bg-amber-600 px-2 py-0.5 text-[10px] text-white">
                            Modifier
                          </button>
                        ) : (
                          <div className="flex flex-col gap-1">
                            <button type="button" onClick={() => void handleSave(userId, s)} className="rounded bg-emerald-600 px-2 py-0.5 text-[10px] text-white">
                              Enregistrer
                            </button>
                            <button type="button" onClick={cancelEdit} className="rounded bg-slate-600 px-2 py-0.5 text-[10px] text-white">
                              Annuler
                            </button>
                          </div>
                        )}
                        <div className="mt-1 text-[9px] text-slate-500">Prém. {Number(s.premium) ? 'oui' : 'non'}</div>
                        {isEd && (
                          <select
                            value={editForm.premium || '0'}
                            onChange={(e) => setEditForm((f: any) => ({ ...f, premium: e.target.value }))}
                            className="mt-1 rounded border border-[#33456f] bg-[#0a1329] px-1 py-0.5 text-[9px] text-slate-100"
                          >
                            <option value="0">Prém. non</option>
                            <option value="1">Prém. oui</option>
                          </select>
                        )}
                        <button
                          type="button"
                          onClick={() => void handleDelete('staff', userId, Number(s.id))}
                          className="mt-1 rounded bg-red-800 px-2 py-0.5 text-[10px] text-white"
                        >
                          Supprimer
                        </button>
                      </td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
          {filteredItems.length === 0 && <p className="p-3 text-xs text-slate-400">Aucun personnel trouvé.</p>}
        </div>
);

export default StaffModerationTab;
